<template>
  <section id="stack" class="p-2">
    <v-container class="pt-5">
      <v-row no-gutters>
        <v-col v-for="icon in icons" :key="icon" cols="3" sm="3">
          <v-icon class="ma-2 pa-2" :icon="icon"></v-icon>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  data() {
    return {
      icons: [
        "mdi-vuejs",
        "mdi-nodejs",
        "mdi-firebase",
        "mdi-language-python",
        "mdi-language-java",
        "mdi-terraform",
        "mdi-android",
        "mdi-language-csharp",
      ],
    };
  },
});
</script>

<style scoped>
#stack {
  background: rgb(52 144 103 / 90%);
}

i {
  font-size: 50px;
  color: rgb(219, 219, 219);
  cursor: pointer;
  filter: drop-shadow(3px 5px 2px rgb(0 0 0 / 0.2));
}

i:hover {
  color: rgb(197, 195, 195);
  transition: 0.3s;
}
</style>
